/**
 * @desc 库存调整单导出
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.stockAdjustmentMaster.exporting.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/export`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
